import { createStyles, Theme } from '@material-ui/core'

export const conceptPriceCardStyles = (theme: Theme) =>
  createStyles({
    dialogContent: {
      // Ocultar completamente el Toolbar vacío del DataTable
      '& .MUIDataTableToolbar-root': {
        display: 'none !important'
      },
      '& [class*="MUIDataTableToolbar-root"]': {
        display: 'none !important'
      },
      '& .MuiToolbar-root[role="toolbar"]': {
        display: 'none !important'
      }
    },
    dialogContentWithFab: {
      // Reducir padding superior para acercar el FAB
      paddingTop: '0px !important'
    }
  })
